import {
  WSPoster,
  WSPosterProps,
  useIsMobile
} from "@wingspanhq/fe-component-library";
import React from "react";

export const RequirementCardContent: React.FC<WSPosterProps> = props => {
  const isMobile = useIsMobile();

  return <WSPoster align={isMobile ? "center" : "left"} size="S" {...props} />;
};
